/**
 * Helper function to decode number chars into word chars
 */

export function decodeChars(el, letter, index, duration = 1) {
  if (
    typeof gsap === "undefined" ||
    typeof ScrollTrigger === "undefined" ||
    typeof SplitText === "undefined"
  ) {
    console.warn("GSAP, ScrollTrigger, or SplitText is not available");
    return;
  }

  // let frameCount = 0;
  // const updateEveryNFrames = 10;

  // return gsap.to(
  //   {},
  //   {
  //     duration: duration,
  //     ease: "none",
  //     onUpdate() {
  //       frameCount++;

  //       if (frameCount % updateEveryNFrames === 0) {
  //         el.textContent = Math.floor(Math.random() * 10);

  //         gsap.killTweensOf(el);

  //         gsap.fromTo(
  //           el,
  //           {
  //             y: index % 2 === 0 ? 20 : -20,
  //             // opacity: 0,
  //           },
  //           {
  //             y: index % 2 === 0 ? -20 : 20,
  //             // opacity: 1,
  //             duration: 0.25,
  //             delay: -0.05,
  //             ease: "none",
  //           },
  //         );
  //       }
  //     },
  //     onComplete() {
  //       el.textContent = letter;
  //       gsap.fromTo(
  //         el,
  //         { opacity: 1, y: index % 2 === 0 ? 20 : -20 },
  //         { opacity: 1, y: 0, duration: 0.2, delay: 0.05, ease: "none" },
  //       );
  //     },
  //   },
  // );

  const rolls = 5;
  const interval = duration / rolls;

  const tl = gsap.timeline({ ease: "none" });

  for (let i = 0; i < rolls; i++) {
    tl.call(
      () => {
        el.textContent = Math.floor(Math.random() * 10);

        gsap.fromTo(
          el,
          { y: index % 2 === 0 ? 20 : -20 },
          {
            y: index % 2 === 0 ? -20 : 20,
            duration: interval,
            ease: "none",
          },
        );
      },
      null,
      i * interval,
    );
  }

  tl.call(
    () => {
      el.textContent = letter;

      gsap.fromTo(
        el,
        { y: index % 2 === 0 ? 30 : -30 },
        {
          y: 0,
          duration: interval,
          ease: "none",
        },
      );
    },
    null,
    duration,
  );

  return tl;
}
